import { render, staticRenderFns } from "./IapPopupModal.vue?vue&type=template&id=a2bec9ea&scoped=true&"
import script from "./IapPopupModal.vue?vue&type=script&lang=js&"
export * from "./IapPopupModal.vue?vue&type=script&lang=js&"
import style0 from "./IapPopupModal.vue?vue&type=style&index=0&id=a2bec9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bec9ea",
  null
  
)

export default component.exports